import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ListadoPerfiles from './components/ListadoPerfiles';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allPerfilesAction, setActivoPerfilesAction } from './PerfilesAction';
import FormPerfiles from './components/FormPerfiles';
import { SnackbarAlertWidget } from '../../../widgets';

const PerfilesView = () => {
  const dispatch = Redux.useDispatch();

  const perfilesStore = Redux.useSelector((state) => state.perfiles);

  return (
    <Grid container spacing={1}>
      <SnackbarAlertWidget alert={perfilesStore.alertView} />
      <Grid item md={12}>
        {perfilesStore.all.length > 0 ? (
          <BotonComponent
            click={async () => {
              await setActivoPerfilesAction(dispatch, null);
              await allPerfilesAction(dispatch, perfilesStore.params);
            }}
            disabled={perfilesStore.loadingAll}
            white
            refreshIcon
            text={perfilesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
          />
        ) : null}
      </Grid>
      <Grid item md={4}>
        <Paper elevation={5} sx={{ pb: 1 }}>
          <FormPerfiles />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoPerfiles />
      </Grid>
    </Grid>
  );
};

export default PerfilesView;
